/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_LATEST_DISPLAY_PLANOGRAM_CHANGE = gql`
  query GetLatestDisplayPlanogramChange($displayId: ID!) {
    displayPlanogramHistory(
      displayId: $displayId
      pagination: { limit: 1, offset: 0 }
    ) {
      id
      created
      completedAt
      completedBy {
        id
        firstName
        lastName
      }
    }
  }
`
